import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';

export default function BackButton({ sx }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <IconButton
      aria-label="Zurück"
      onClick={handleBack}
      sx={sx}
      size="large"
    >
      <ArrowBackIosNewIcon />
    </IconButton>
  );
}
